import styled from 'styled-components';

export const FailedLogin = styled.div`
  margin-bottom: 20px;
  color: #edbd2f;
  line-height: 18px;
  @media (max-width: 480px){
    font-size: 12px;
  }
`;

export const SpanWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 480px){
    flex-direction: column;
  }
`;



// WEBPACK FOOTER //
// ./src/auth/components.js